import { SelectOption } from "@iddataweb/idw-common-ui/types";
import { AxnAdminUserPropertyBundleTypes } from "@enums/axn-admin-user-property-bundle-types";

export const USER_ROLE_TYPE_OPTIONS: Array<SelectOption> = [
    { label: "Organization", value: AxnAdminUserPropertyBundleTypes.ORGANIZATION },
    { label: "Relying Party", value: AxnAdminUserPropertyBundleTypes.RP }
];